import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    margin: '-32px',
  },
  tabContainer: {
    padding: theme.spacing(0, 5),
    borderBottom: `1px solid ${theme.palette.labraV2BoxShadow.dark}`,
    background: theme.palette.bg.main,
  },
  content: {
    padding: theme.spacing(4, 5),
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}))
